import React, { useState } from "react";
import "./ChangePassword.scss";
import hideIcon from "./img/hide.png";
import showIcon from "./img/show.png";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../../awsAuth";

const ChangePassword = () => {
  const navigate = useNavigate();

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [visibleFields, setVisibleFields] = useState({
    old: false,
    new: false,
    repeat: false,
  });
  const [activeField, setActiveField] = useState(null);

  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null);

  const toggleVisibility = (field) =>
    setVisibleFields((prev) => ({ ...prev, [field]: !prev[field] }));

  const handleForgotPassword = () => {
    navigate("/auth", { state: { step: "forgot", fromSettings: true } });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    setStatus(null);
    setSubmitting(true);

    try {
      await changePassword(oldPassword, newPassword);

      setStatus({ type: "success", message: "Пароль успішно змінено." });

      setOldPassword("");
      setNewPassword("");
      setRepeatPassword("");

      setTimeout(() => {
        navigate("/profile");
      }, 1000);
    } catch (err) {
      const code = err?.code || err?.name;
      let msg = err?.message || "Не вдалося змінити пароль.";

      if (code === "NotAuthorizedException") msg = "Старий пароль введено невірно.";

      setStatus({ type: "error", message: msg });
    } finally {
      setSubmitting(false);
    }
  };

  const canSubmit =
    oldPassword && newPassword && repeatPassword && newPassword === repeatPassword;

  return (
    <div className="change-password page-enter">
      <div className="cp-header">
        <h2>Зміна паролю</h2>
        <p>Оновіть пароль облікового запису</p>
      </div>

      {status && (
        <div className={`cp-status cp-status--${status.type}`} role="alert">
          {status.message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="cp-card">
        <div className="password-field">
          <label>Старий пароль</label>
          <div
            className={`input-wrapper ${
              activeField === "old" ? "is-active" : ""
            }`}
          >
            <input
              type={visibleFields.old ? "text" : "password"}
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              onFocus={() => setActiveField("old")}
              onBlur={() => setActiveField(null)}
              placeholder="Введіть старий пароль"
              autoComplete="current-password"
            />
            {activeField === "old" && (
              <img
                src={visibleFields.old ? hideIcon : showIcon}
                alt=""
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => toggleVisibility("old")}
                className="eye-icon"
              />
            )}
          </div>
        </div>

        <div className="password-field">
          <label>Новий пароль</label>
          <div
            className={`input-wrapper ${
              activeField === "new" ? "is-active" : ""
            }`}
          >
            <input
              type={visibleFields.new ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              onFocus={() => setActiveField("new")}
              onBlur={() => setActiveField(null)}
              placeholder="Введіть новий пароль"
              autoComplete="new-password"
            />
            {activeField === "new" && (
              <img
                src={visibleFields.new ? hideIcon : showIcon}
                alt=""
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => toggleVisibility("new")}
                className="eye-icon"
              />
            )}
          </div>

          {activeField === "new" && (
            <div className="password-rules">
              <p>Пароль має містити:</p>
              <ul>
                <li>Мінімум 8 символів</li>
                <li>Один спецсимвол (! @ # …)</li>
                <li>Велику і малу літери</li>
                <li>Щонайменше одну цифру</li>
              </ul>
            </div>
          )}
        </div>

        <div className="password-field">
          <label>Повторіть новий пароль</label>
          <div
            className={`input-wrapper ${
              activeField === "repeat" ? "is-active" : ""
            }`}
          >
            <input
              type={visibleFields.repeat ? "text" : "password"}
              value={repeatPassword}
              onChange={(e) => setRepeatPassword(e.target.value)}
              onFocus={() => setActiveField("repeat")}
              onBlur={() => setActiveField(null)}
              placeholder="Повторіть новий пароль"
              autoComplete="new-password"
            />
            {activeField === "repeat" && (
              <img
                src={visibleFields.repeat ? hideIcon : showIcon}
                alt=""
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => toggleVisibility("repeat")}
                className="eye-icon"
              />
            )}
          </div>
          {!!repeatPassword && newPassword !== repeatPassword && (
            <div className="mismatch">Паролі не співпадають</div>
          )}
        </div>

        <button type="button" className="forgot-password" onClick={handleForgotPassword}>
          Забули пароль?
        </button>

        <button type="submit" className="save-btn" disabled={!canSubmit || submitting}>
          {submitting ? "Збереження..." : "Зберегти зміни"}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
